import { render } from "./HelpDeletePart.vue?vue&type=template&id=2ef773fb"
import script from "./HelpDeletePart.vue?vue&type=script&lang=js"
export * from "./HelpDeletePart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__